import { useTranslation } from 'react-i18next'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { ApiError, NetworkError } from '@/lib/api/errors'
import { RotateCcw } from 'lucide-react'

interface Props {
  error: unknown
  reset?: () => void
}

export function RootErrorBoundary({ error, reset }: Props) {
  const { t } = useTranslation()
  let title: string = t('errors.title')
  let body: string = t('errors.genericBody')

  if (error instanceof NetworkError) {
    title = t('errors.networkTitle')
    body = t('errors.networkBody')
  } else if (error instanceof ApiError) {
    if (error.status === 401) {
      title = t('errors.unauthorizedTitle')
      body = t('errors.unauthorizedBody')
    } else if (error.status === 403) {
      title = t('errors.forbiddenTitle')
      body = t('errors.forbiddenBody')
    } else if (typeof error.detail === 'string' && error.detail) {
      body = error.detail
    }
  } else if (error instanceof Error && error.message) {
    body = error.message
  }

  return (
    <div className="grid min-h-[40vh] place-items-center p-8">
      <div className="w-full max-w-md">
        <Alert variant="destructive">
          <AlertTitle>{title}</AlertTitle>
          <AlertDescription className="mt-1">{body}</AlertDescription>
        </Alert>
        {reset ? (
          <div className="mt-3 flex justify-end">
            <Button onClick={reset} variant="secondary">
              <RotateCcw className="mr-1.5 h-4 w-4" />
              {t('common.retry')}
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  )
}
